export default __webpack_public_path__ + "static/media/advantages_5.b5d45ed5.svg";